import { Controller } from '@hotwired/stimulus';
import alertify from 'shared/alertify';

// FIXME: スコープ外の要素にアクセスしているので Outlet の利用を検討
export default class extends Controller {
  // action="click->preview-modal#open"
  async open(event) {
    event.preventDefault();

    let html;
    try {
      const response = await fetch(this.element.href, {
        headers: { Accept: 'text/html' },
      });
      if (!response.ok) throw new Error(response.statusText);
      html = await response.text();
    } catch (error) {
      console.error(error);
      alertify.error('エラー');
      $('#previewModal').modal('hide');
      return;
    }

    const height =
      (window.innerHeight || document.documentElement.clientHeight) * 0.75;
    $('#previewModal').html(html).modal();
    $('#previewModal').find('.outer .inner').css({ height });
  }
}
